export interface Asset {

}

export function launchImageLibrary(params:any){
return new Promise<any>(r=>r({}))
}